import React from 'react'
import { Content } from '../../../components'
import { editorials } from '../editorials/articles'

export const WelcomePage = () => {
  const welcomeArticles = editorials.filter((article) => article.welcomeGift)
  const weeklyEditions = editorials
    .filter((article) => article.category === 'Weekly Edition')
    .sort(
      (firstArticle, secondArticle) =>
        new Date(secondArticle.publishedAt).getTime() -
        new Date(firstArticle.publishedAt).getTime()
    )

  const latestEdition = weeklyEditions[0]
  const archivedEditions = weeklyEditions.slice(1)

  return (
    <Content padding="0">
      <main
        style={{
          minHeight: '100vh',
          padding: '72px clamp(20px, 7vw, 110px)',
          backgroundColor: '#171714',
          color: '#f3efe7',
          fontFamily: 'Georgia, "Times New Roman", serif'
        }}
      >
        <section
          style={{
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '24px',
              paddingBottom: '20px',
              borderBottom: '1px solid #f3efe7',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '11px',
              letterSpacing: '2px',
              textTransform: 'uppercase'
            }}
          >
            <span>Made to Wear</span>
            <span>By OvafloPick</span>
          </div>

          <header
            style={{
              padding: '72px 0',
              borderBottom: '1px solid #f3efe7'
            }}
          >
            <p
              style={{
                margin: '0 0 24px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '11px',
                letterSpacing: '3px',
                textTransform: 'uppercase'
              }}
            >
              Welcome
            </p>

            <h1
              style={{
                maxWidth: '1000px',
                margin: '0 0 36px',
                fontSize: 'clamp(52px, 7vw, 96px)',
                lineHeight: '1',
                fontWeight: 400,
                letterSpacing: '-0.06em'
              }}
            >
              Welcome to Made to Wear
            </h1>

            <p
              style={{
                maxWidth: '720px',
                margin: 0,
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '19px',
                lineHeight: '1.8'
              }}
            >
              A thoughtful insight about craftsmanship, custom-made fashion and
              the remarkable people who bring exceptional pieces to life.
            </p>
          </header>

          <section
            style={{
              padding: '72px 0',
              borderBottom: '1px solid #f3efe7'
            }}
          >
            <p
              style={{
                margin: '0 0 20px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '11px',
                letterSpacing: '3px',
                textTransform: 'uppercase'
              }}
            >
              The journey
            </p>

            <h2
              style={{
                margin: '0 0 28px',
                fontSize: 'clamp(38px, 5vw, 60px)',
                lineHeight: '1.05',
                fontWeight: 400,
                letterSpacing: '-0.05em'
              }}
            >
              Begin Here
            </h2>

            <div
              style={{
                maxWidth: '760px',
                marginBottom: '52px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '18px',
                lineHeight: '1.75'
              }}
            >
              <p>
                Whether you&apos;re exploring custom-made fashion for the first
                time or simply curious about how it works, these three guides
                will help you begin with greater clarity and confidence.
              </p>

              <p>
                Start with the first guide, or choose the subject that feels
                most useful to you today.
              </p>
            </div>

            <div
              style={{
                borderTop: '1px solid #f3efe7'
              }}
            >
              {welcomeArticles.map((article, articleIndex) => (
                <article
                  key={article.slug}
                  style={{
                    display: 'grid',
                    gridTemplateColumns:
                      'minmax(70px, 100px) minmax(0, 1fr) auto',
                    gap: '24px',
                    alignItems: 'center',
                    padding: '36px 0',
                    borderBottom: '1px solid #f3efe7'
                  }}
                >
                  <div
                    style={{
                      alignSelf: 'start'
                    }}
                  >
                    <span
                      style={{
                        display: 'block',
                        marginBottom: '10px',
                        fontSize: '34px',
                        lineHeight: 1
                      }}
                    >
                      {String(articleIndex + 1).padStart(2, '0')}
                    </span>

                    <span
                      style={{
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '10px',
                        letterSpacing: '2px',
                        textTransform: 'uppercase'
                      }}
                    >
                      {article.category}
                    </span>
                  </div>

                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: 'clamp(26px, 4vw, 46px)',
                        lineHeight: '1.05',
                        fontWeight: 400
                      }}
                    >
                      {article.title}
                    </h3>

                    <p
                      style={{
                        maxWidth: '680px',
                        margin: '14px 0 0',
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '17px',
                        lineHeight: '1.7'
                      }}
                    >
                      {article.summary}
                    </p>
                  </div>

                  <a
                    href={`/madetowear/${article.slug}`}
                    style={{
                      color: '#f3efe7',
                      fontFamily: 'Arial, Helvetica, sans-serif',
                      fontSize: '11px',
                      fontWeight: 700,
                      letterSpacing: '2px',
                      textDecoration: 'none',
                      textTransform: 'uppercase',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Continue Reading →
                  </a>
                </article>
              ))}
            </div>
          </section>

          <section
            style={{
              padding: '72px 0 20px'
            }}
          >
            {latestEdition && (
              <section
                style={{
                  padding: '72px 0',
                  borderBottom: '1px solid #f3efe7'
                }}
              >
                <p
                  style={{
                    margin: '0 0 20px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '11px',
                    letterSpacing: '3px',
                    textTransform: 'uppercase'
                  }}
                >
                  Latest Editorial
                </p>

                <p
                  style={{
                    margin: '0 0 24px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '12px',
                    letterSpacing: '2px',
                    textTransform: 'uppercase'
                  }}
                >
                  {new Date(
                    `${latestEdition.publishedAt}T00:00:00`
                  ).toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </p>

                <h2
                  style={{
                    maxWidth: '950px',
                    margin: '0 0 28px',
                    fontSize: 'clamp(34px, 5vw, 56px)',
                    lineHeight: '1.05',
                    fontWeight: 400,
                    letterSpacing: '-0.05em'
                  }}
                >
                  {latestEdition.title}
                </h2>

                <p
                  style={{
                    maxWidth: '720px',
                    margin: '0 0 36px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '18px',
                    lineHeight: '1.75'
                  }}
                >
                  {latestEdition.summary}
                </p>

                <a
                  href={`/madetowear/${latestEdition.slug}`}
                  style={{
                    display: 'inline-block',
                    padding: '17px 28px',
                    border: '1px solid #f3efe7',
                    color: '#f3efe7',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    textDecoration: 'none',
                    textTransform: 'uppercase'
                  }}
                >
                  Continue Reading →
                </a>
              </section>
            )}
            {archivedEditions.length > 0 && (
              <section
                style={{
                  padding: '72px 0',
                  borderBottom: '1px solid #f3efe7'
                }}
              >
                <p
                  style={{
                    margin: '0 0 20px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '11px',
                    letterSpacing: '3px',
                    textTransform: 'uppercase'
                  }}
                >
                  Previous Editorials
                </p>

                <h2
                  style={{
                    margin: '0 0 48px',
                    fontSize: 'clamp(30px, 4vw, 46px)',
                    lineHeight: '0.95',
                    fontWeight: 400,
                    letterSpacing: '-0.05em'
                  }}
                >
                  Recent Editorials
                </h2>

                <div
                  style={{
                    borderTop: '1px solid #f3efe7'
                  }}
                >
                  {archivedEditions.map((article) => (
                    <article
                      key={article.slug}
                      style={{
                        display: 'grid',
                        gridTemplateColumns:
                          'minmax(170px, 230px) minmax(0, 1fr) auto',
                        gap: '24px',
                        alignItems: 'center',
                        padding: '28px 0',
                        borderBottom: '1px solid #f3efe7'
                      }}
                    >
                      <time
                        dateTime={article.publishedAt}
                        style={{
                          fontFamily: 'Arial, Helvetica, sans-serif',
                          fontSize: '12px',
                          letterSpacing: '1px'
                        }}
                      >
                        {new Date(
                          `${article.publishedAt}T00:00:00`
                        ).toLocaleDateString('en-US', {
                          month: 'long',
                          day: 'numeric',
                          year: 'numeric'
                        })}
                      </time>

                      <h3
                        style={{
                          margin: 0,
                          fontSize: 'clamp(20px, 2.8vw, 28px)',
                          lineHeight: '1.1',
                          fontWeight: 400
                        }}
                      >
                        {article.title}
                      </h3>

                      <a
                        href={`/madetowear/${article.slug}`}
                        style={{
                          color: '#f3efe7',
                          fontFamily: 'Arial, Helvetica, sans-serif',
                          fontSize: '11px',
                          fontWeight: 700,
                          letterSpacing: '2px',
                          textDecoration: 'none',
                          textTransform: 'uppercase',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        Continue Reading →
                      </a>
                    </article>
                  ))}
                </div>
                <a
  href="/madetowear/archive"
  style={{
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: '40px',
    color: '#f3efe7',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '2px',
    textDecoration: 'none',
    textTransform: 'uppercase',
  }}
>
  View Publication Archive →
</a>
              </section>
            )}
            <p
              style={{
                margin: '0 0 18px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '11px',
                letterSpacing: '3px',
                textTransform: 'uppercase'
              }}
            ></p>

            <h2
              style={{
                maxWidth: '850px',
                margin: '0 0 28px',
                fontSize: 'clamp(34px, 5vw, 54px)',
                lineHeight: '1.05',
                fontWeight: 400,
                letterSpacing: '-0.05em'
              }}
            >
              Explore custom-made fashion on OvafloPick
            </h2>

            <p
              style={{
                maxWidth: '650px',
                margin: '0 0 36px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '18px',
                lineHeight: '1.75'
              }}
            >
              Browse exceptional pieces or get connected to custom makers
              for your bespoke clothing, shoes, bags and accessories.
            </p>

            <a
              href="/"
              style={{
                display: 'inline-block',
                padding: '17px 28px',
                backgroundColor: '#f3efe7',
                color: '#171714',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '2px',
                textDecoration: 'none',
                textTransform: 'uppercase'
              }}
            >
              Shop OvafloPick
            </a>
          </section>
        </section>
      </main>
    </Content>
  )
}
